export const filterValidSelectedAttachments = <T extends { tempUniqueId?: string }>(
    selectedAttachments: T[] = [],
    currentRows: Array<{ tempUniqueId?: string }> = []
) => {
    if (!selectedAttachments.length) return []

    const validIds = new Set(
        currentRows
            .map(row => row.tempUniqueId)
            .filter((tempUniqueId): tempUniqueId is string => Boolean(tempUniqueId))
    )

    return selectedAttachments.filter(row => {
        if (!row.tempUniqueId) return false
        return validIds.has(row.tempUniqueId)
    })
}
